import { createContext, useContext } from 'react';

export interface SlideOverFloatingLayer {
  layer: HTMLElement;
  panel: HTMLElement;
}

export const SlideOverFloatingLayerContext = createContext<SlideOverFloatingLayer | null>(null);

/** The enclosing drawer's floating layer and the panel it sits beside; null outside a drawer. */
export const useSlideOverFloatingLayer = (): SlideOverFloatingLayer | null =>
  useContext(SlideOverFloatingLayerContext);
